import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Walking in without a plan, because you never know who will show up', 'New faces every week, and half the group gone before the third session', 'The music is on, and still nobody starts moving', 'A plan built for an energetic room, and the room is quiet', 'Someone pacing, someone who won\'t look up, someone in a wheelchair, all in one circle', 'The group that says no to every suggestion', 'Your ideas drying up, and the same warm-up and songs on repeat', 'Building a whole session from scratch, for every group, every week'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-night" data-id="element-202" data-mp="1bq4epzhasdk7">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-203" data-mp="17papn2s4cspq">
        <div className="text-center" data-id="element-204" data-mp="363lswvvtby2k">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-shuttle" data-id="element-205" data-mp="362kh2p6z37js">
            The reality of leading groups
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold text-white text-[28px] sm:text-4xl md:text-5xl leading-tight tracking-tight" data-id="element-206" data-mp="320fqy0fqgt1w">
            If you lead movement groups, you know at least{' '}
            <span className="text-coral-soft" data-id="element-207" data-mp="379gj68gxvvaj">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-208" data-mp="3bb1qleapfhdc">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-night-line bg-night-card px-4 py-4 text-sm text-white/85" data-id="element-209" data-mp="2vi5x3o3n79w">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/25" data-id="element-210" data-mp="3q682ghwheael">
                <XIcon className="h-3 w-3 text-coral-soft" aria-hidden="true" data-id="element-211" data-mp="3u7bgcyuyxwd6" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display font-bold text-xl sm:text-3xl text-shuttle leading-tight" data-id="element-212" data-mp="qkazwul5v51v">
          How many more groups do you want to build from zero?
        </p>
      </div>
    </section>;
}